var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsContentInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 8c.53 0 .964.43.998.973l.002.069v4.916c0 .576-.448 1.042-1 1.042-.53 0-.964-.43-.998-.973L11 15.958v-4.916c0-.576.448-1.042 1-1.042zm0-1a1 1 0 100-2 1 1 0 000 2z",
    fill: "red"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyQzYuNDc3MDIgMiAyIDYuNDc3MjMgMiAxMkMyIDE3LjUyMjggNi40NzcwMiAyMiAxMiAyMkMxNy41MjI4IDIyIDIyIDE3LjUyMjggMjIgMTJDMjIgNi40NzcyMyAxNy41MjI4IDIgMTIgMlpNMTIgMTBDMTIuNTMwMiAxMCAxMi45NjQgMTAuNDI5OCAxMi45OTc5IDEwLjk3MzJMMTMgMTEuMDQxN1YxNS45NTgzQzEzIDE2LjUzMzYgMTIuNTUyMyAxNyAxMiAxN0MxMS40Njk4IDE3IDExLjAzNiAxNi41NzAyIDExLjAwMjEgMTYuMDI2OEwxMSAxNS45NTgzVjExLjA0MTdDMTEgMTAuNDY2NCAxMS40NDc3IDEwIDEyIDEwWk0xMiA5QzEyLjU1MjMgOSAxMyA4LjU1MjI4IDEzIDhDMTMgNy40NDc3MiAxMi41NTIzIDcgMTIgN0MxMS40NDc3IDcgMTEgNy40NDc3MiAxMSA4QzExIDguNTUyMjggMTEuNDQ3NyA5IDEyIDlaIiBmaWxsPSJyZWQiLz4KPC9zdmc+Cg==";
export { SvgIconsContentInformation as ReactComponent };